import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { getPlaylists } from '../actions/playlistActions';

import { Link, useNavigate } from 'react-router-dom';
import Cover from './Cover';
import {
    Button,
    CircularProgress,
    Grid2 as Grid,
    InputBase,
} from '@mui/material';

import Icon from '@mdi/react';
import { mdiMusic, mdiMagnify, mdiHomeCircleOutline } from '@mdi/js';
import { PLAYLIST_GET_FAIL, QUEUE_NAME } from '../actions/types';

function Playlists() {
    const [word, setWord] = useState('');
    const dispatch = useDispatch();
    const playlists = useSelector((state) => state.playlist.items);
    const progress = useSelector((state) => state.playlist.progress);

    const navigate = useNavigate();

    return (
        <>
            <Button
                component={Link}
                to="/"
                onClick={() => dispatch({ type: PLAYLIST_GET_FAIL })}
                sx={{
                    background: 'transparent',
                    minWidth: '40px',
                    height: '40px',
                    padding: 0,
                    borderRadius: '50%',
                    position: 'aboslute',
                    left: '20px',
                    top: '20px',
                    marginBottom: '8px',
                    color: 'darkred',
                    '&:hover': {
                        color: 'black',
                    },
                }}
            >
                <Icon
                    path={mdiHomeCircleOutline}
                    size={1.7}
                    style={{ color: 'inherit' }}
                />
            </Button>
            <div
                style={{
                    display: 'flex',
                    marginBottom: '30px',
                    marginTop: '20px',
                    justifyContent: 'center',
                    marginLeft: '20px',
                    marginRight: '20px',
                }}
            >
                <Button
                    type="button"
                    sx={{
                        background: 'black',
                        minWidth: '30px',
                        borderRadius: '50% 0% 0% 50%',
                        border: '1px solid black',
                    }}
                    disabled
                >
                    <Icon path={mdiMusic} size={1} style={{ color: 'white' }} />
                </Button>
                <div style={{ border: '1px solid black' }}>
                    <InputBase
                        sx={{ ml: 1, flex: 1, mr: 1, minWidth: '50vw' }}
                        autoFocus
                        placeholder="Playlist suchen"
                        value={word}
                        onChange={(e) => setWord(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13 && word.trim().length > 0) {
                                dispatch(getPlaylists(word));
                            }
                        }}
                        slotProps={{
                            input: {
                                sx: { height: '27px' },
                            },
                        }}
                    />
                </div>
                <Button
                    type="button"
                    sx={{
                        background: 'black',
                        minWidth: '30px',
                        borderRadius: '0% 50% 50% 00%',
                        border: '1px solid black',
                        '&:hover': {
                            background: 'darkred',
                            borderColor: 'darkred',
                        },
                    }}
                    disabled={word.trim().length === 0 || progress}
                    onClick={() => dispatch(getPlaylists(word))}
                >
                    <Icon
                        path={mdiMagnify}
                        size={1}
                        style={{ color: 'white' }}
                    />
                </Button>
            </div>
            {progress ? (
                <div
                    style={{
                        position: 'absolute',
                        top: 'calc(50% - ((10vw + 10px + 20px) / 2))',
                        left: 'calc(50%)',
                        transform: 'translate(-50%, -50%)',
                        justifyContent: 'center',
                        display: 'grid',
                    }}
                >
                    <CircularProgress
                        sx={{
                            color: 'darkred',
                            margin: 'auto',
                            marginBottom: '10px',
                        }}
                        size="10vw"
                    />
                    <div
                        style={{
                            lineHeight: '20px',
                            height: '20px',
                            textAlign: 'center',
                        }}
                    >
                        übereinstimmende Playlists werden gesucht
                    </div>
                </div>
            ) : (
                <Grid
                    container
                    spacing={2}
                    sx={{ justifyContent: 'center', mb: 3 }}
                >
                    {playlists.map((playlist) => (
                        <Grid
                            item
                            key={playlist.id}
                            size={{ xs: '6', sm: '4', lg: '3', xl: '2' }}
                        >
                            <div
                                onClick={() => {
                                    dispatch({
                                        type: QUEUE_NAME,
                                        payload: { name: playlist.name },
                                    });
                                    navigate(`/playlists/${playlist.id}`);
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                {playlist.images?.length > 0 ? (
                                    <Cover
                                        image={playlist.images[0].url}
                                        title={playlist.name}
                                    />
                                ) : null}
                            </div>
                        </Grid>
                    ))}
                </Grid>
            )}
        </>
    );
}

export default Playlists;
